<template>
  <div class="privacy-box">
    <privacy></privacy>
  </div>
</template>
<script>
import privacy from "@/components/privacy";
export default {
  name: "Home",
  components: {
    privacy
  },
  data () {
    return {
    };
  },
  methods: {
  }
}
</script>

